<div class="container my-3">
  <!-- <h1 class="mb-4">Add Train</h1> -->

  <!-- Form Start -->
  <form #form="ngForm" (ngSubmit)="addTrain()" class="mt-2">
    <div>
        <!-- Commented on 12th may 2026 for the breadcrumb changes -->
      <!-- <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="PlantId" class="form-label">Plant :</label>
        </div>
        <div class="col-sm-4">
          <select class="form-select border border-dark" name="PlantId" (change)="getSelectedPlantId($event)"
            id="PlantId" [(ngModel)]="addTrainRequest.PlantId" #plantId="ngModel">
            <option [ngValue]="0" [selected]="!plantSelected">
              Select Plant
            </option>
            <option *ngFor="let plant of plants" [ngValue]="plant.Id">
              {{ plant.Name }}
            </option>
          </select>
          <div *ngIf="plantValidator">This field is required</div>
          <div *ngIf="
              addTrainRequest.PlantId === 0 &&
              (plantId.touched || plantId.dirty)
            ">
            This field is required
          </div>
        </div>
      </div> -->

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="name" class="form-label">Name:</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control border border-dark" id="name" name="name"
            [(ngModel)]="addTrainRequest.Name" minlength="2" autocomplete="on" #nameField="ngModel"
            (input)="nameChange()" />
          <div *ngIf="nameField.invalid && (nameField.dirty || nameField.touched)">
            <div *ngIf="nameField.errors.minlength">
              Please enter at least 2 characters.
            </div>
          </div>
          <div *ngIf="nameValidator">This field is required</div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="AccessOptions" class="form-label">User Access:</label>
        </div>
        <div class="col-sm-4">
          <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.AccessOption" name="AccessOption"
            id="AccessOption" (change)="onAccessOptionSelected($event)">
            <option *ngFor="let access of useraccessOption" [ngValue]="access.Id">
              {{ access.Name }}
            </option>
          </select>
        </div>
      </div>

      <div>
        <div class="row mb-3" id="divUser" *ngIf="!addTrainRequest.NoUserSelected">
          <div class="col-sm-3" style="text-align: left">
            <label for="users" class="form-label">(press control key for multiple user selection)</label>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <ng-select [items]="comanyUsers" bindLabel="FirstName" [multiple]="true" placeholder="Select a User"
                [(ngModel)]="selectedValues" [ngModelOptions]="{ standalone: true }" appearance="outline"
                appendTo="body" [closeOnSelect]="false" (change)="selecteduser($event)">
                >
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="notes" class="form-label">Notes:</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control border border-dark" id="Notes" name="Notes"
            [(ngModel)]="addTrainRequest.Notes" autocomplete="on" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="Units" class="form-label">Unit:</label>
        </div>
        <div class="col-sm-4">
          <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Units" name="Units" id="Units">
            <option *ngFor="let unit of units" [ngValue]="unit.Id">
              {{ unit.UnitName }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="Stages" class="form-label"># of Stages:</label>
        </div>
        <div class="col-sm-4">
          <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stages" name="Stages" id="Stages"
            (change)="onOptionSelected()">
          
            <option *ngFor="let stages of stage" [ngValue]="stages.Id">
              {{ stages.Name }}
            </option>
          </select>
         
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="Tcfa" class="form-label">TCFA:</label>
        </div>
        <div class="col-sm-4">
          <input type="number" class="form-control border border-dark" id="Tcfa" name="Tcfa"
            [(ngModel)]="addTrainRequest.Tcfa" autocomplete="on" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="Tcfb" class="form-label">TCFB:</label>
        </div>
        <div class="col-sm-4">
          <input type="number" class="form-control border border-dark" id="Tcfb" name="Tcfb"
            [(ngModel)]="addTrainRequest.Tcfb" autocomplete="on" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <b>Stage 1</b>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="Hybrid" class="form-label">Hybrid:</label>
        </div>
        <div class="col-sm-4">
          <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Hybrid" name="Hybrid" id="Hybrid"
            (change)="onOptionHybrid()">
            <option *ngFor="let hybrids of hybrid" [ngValue]="hybrids.Id">
              {{ hybrids.Name }}
            </option>
          </select>
        </div>
      </div>

      <div id="stage1Nhybrid" *ngIf="showHybrid">
        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1Element1Model" class="form-label">Element:</label>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stage1Element1Model"
                name="Stage1Element1Model" id="Stage1Element1Model" #Stage1Element1Model="ngModel">
                <option [ngValue]="0">Select a Model</option>
                <option *ngFor="let model of models" [ngValue]="model.Id">
                  {{ model.Name }}
                </option>
              </select>
             
              <div *ngIf="stage1eleement1validator">This field is required</div>
              <div *ngIf="
                  addTrainRequest.Stage1Element1Model === 0 &&
                  (Stage1Element1Model.touched || Stage1Element1Model.dirty)
                ">
                This field is required
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1ElementsVessel" class="form-label">Elements/Vessels:</label>
          </div>
          <div class="col-sm-4">
            <input type="text" class="form-control border border-dark" id="Stage1ElementsVessel"
              name="Stage1ElementsVessel" [(ngModel)]="addTrainRequest.Stage1ElementsVessel" autocomplete="on"
              #Stage1ElementsVessel="ngModel" (input)="Stage1ElementsVesselChange()" />
            <div *ngIf="
                Stage1ElementsVessel.invalid &&
                (Stage1ElementsVessel.dirty || Stage1ElementsVessel.touched)
              ">
              This field is required
            </div>
            <div *ngIf="Stage1elementVesselsValidator">
              This field is required
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1Vessels" class="form-label"># Of Vessels:</label>
          </div>
          <div class="col-sm-4">
            <input type="text" class="form-control border border-dark" id="Stage1Vessels" name="Stage1Vessels"
              [(ngModel)]="addTrainRequest.Stage1Vessels" autocomplete="on" #Stage1Vessels="ngModel"
              (input)="Stage1VesselsChange()" />
            <div *ngIf="
                Stage1Vessels.invalid &&
                (Stage1Vessels.dirty || Stage1Vessels.touched)
              ">
              This field is required
            </div>
            <div *ngIf="stage1VesselValidator">This field is required</div>
          </div>
        </div>
      </div>

      <div id="stage1hybrid" *ngIf="showStage1hybrid">
        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1ElementModel" class="form-label">Element1:</label>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stage1Element1Model"
                name="Stage1Element1Model" id="Stage1Element1Model" #Stage1Element1Model="ngModel">
                <option [ngValue]="0">Select a Model</option>
                <option *ngFor="let model of models" [ngValue]="model.Id">
                  {{ model.Name }}
                </option>
              </select>
              <div *ngIf="stage1element1hybridvalidator">
                This field is required
              </div>
              <div *ngIf="
                  addTrainRequest.Stage1Element1Model === 0 &&
                  (Stage1Element1Model.touched || Stage1Element1Model.dirty)
                ">
                This field is required
              </div>
            </div>
          </div>
          <div class="col-sm-1" style="text-align: left">
            <label for="Stage1Element1Qty" class="form-label">Qty:</label>
          </div>
          <div class="col-sm-3" style="text-align: left">
            <input type="text" class="form-control border border-dark" id="Stage1Element1Qty" name="Stage1Element1Qty"
              [(ngModel)]="addTrainRequest.Stage1Element1Qty" autocomplete="on" (change)="QuantityAdditionStage1()"
              #Stage1Element1Qty="ngModel" (input)="Stage1Q1Change()" />
            <div *ngIf="
                Stage1Element1Qty.invalid &&
                (Stage1Element1Qty.dirty || Stage1Element1Qty.touched)
              ">
              This field is required
            </div>
            <div *ngIf="s1Q1Validator">This field is required</div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1Element2Model" class="form-label">Element2:</label>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stage1Element2Model"
                name="Stage1Element2Model" id="Stage1Element2Model" #Stage1Elemen2tModel="ngModel">
                <option [ngValue]="0">Select a Model</option>
                <option *ngFor="let model of models" [ngValue]="model.Id">
                  {{ model.Name }}
                </option>
              </select>
              <div *ngIf="stage1element2hybridvalidator">
                This field is required
              </div>
              <div *ngIf="
                  addTrainRequest.Stage1Element2Model === 0 &&
                  (Stage1Elemen2tModel.touched || Stage1Elemen2tModel.dirty)
                ">
                This field is required
              </div>
            </div>
          </div>
          <div class="col-sm-1" style="text-align: left">
            <label for="Stage1Element2Qty" class="form-label">Qty:</label>
          </div>
          <div class="col-sm-3">
            <input type="text" class="form-control border border-dark" id="Stage1Element2Qty" name="Stage1Element2Qty"
              [(ngModel)]="addTrainRequest.Stage1Element2Qty" autocomplete="on" (change)="QuantityAdditionStage1()"
              #Stage1Element2Qty="ngModel" (input)="Stage1Q2Change()" />
            <div *ngIf="
                Stage1Element2Qty.invalid &&
                (Stage1Element2Qty.dirty || Stage1Element2Qty.touched)
              "></div>
            <div *ngIf="s1Q2Validator">This field is required</div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1Element3Model" class="form-label">Element3:</label>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stage1Element3Model"
                name="Stage1Element3Model" id="Stage1Element3Model" #Stage1ElementModel="ngModel">
                <option [ngValue]="0">Select a Model</option>
                <option *ngFor="let model of models" [ngValue]="model.Id">
                  {{ model.Name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-1" style="text-align: left">
            <label for="Stage1Element3Qty" class="form-label">Qty:</label>
          </div>

          <div class="col-sm-3">
            <input type="text" class="form-control border border-dark" id="Stage1Element3Qty" name="Stage1Element3Qty"
              [(ngModel)]="addTrainRequest.Stage1Element3Qty" autocomplete="on" (change)="QuantityAdditionStage1()" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1ElementsVessel" class="form-label">Elements/Vessels</label>
          </div>
          <div class="col-sm-4">
            <input type="text" class="form-control border border-dark" id="Stage1ElementsVessel"
              name="Stage1ElementsVessel" [(ngModel)]="addTrainRequest.Stage1ElementsVessel" [disabled]="true"
              autocomplete="on" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Stage1Vessels" class="form-label"># Of Vessels</label>
          </div>
          <div class="col-sm-4">
            <input type="text" class="form-control border border-dark" id="Stage1VesselsH" name="Stage1VesselsH"
              [(ngModel)]="addTrainRequest.Stage1Vessels" autocomplete="on" #Stage1VesselsH="ngModel"
              (input)="Stage1VesselsHChange()" />
            <div *ngIf="
                Stage1VesselsH.invalid &&
                (Stage1VesselsH.dirty || Stage1VesselsH.touched)
              ">
              This field is required
            </div>
            <div *ngIf="stage1VesselValidatorH">This field is required</div>
          </div>
        </div>
      </div>

      <!-- stage 2 Starts -->
      <div id="stage2" *ngIf="showDiv">
        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <b>Stage 2</b>
          </div>
          <div class="col-sm-4"></div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Hybrid2" class="form-label">Hybrid</label>
          </div>
          <div class="col-sm-4">
            <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Hybrid2" name="Hybrid2"
              id="Hybrid2" (change)="onOptionHybridS2()">
              <option *ngFor="let hybrids2 of hybridSt2" [ngValue]="hybrids2.Id">
                {{ hybrids2.Name }}
              </option>
            </select>
          </div>
        </div>

        <!-- stage 2 non hybrid -->
        <div id="stage2Nhybrid" *ngIf="stage2Nhybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2ElementModel" class="form-label">Element:</label>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stage2ElementModel"
                  name="Stage2ElementModel" id="Stage2ElementModel" #Stage2ElementModel="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
                <div *ngIf="stage2Element1validator">
                  This field is required
                </div>
                <div *ngIf="
                    addTrainRequest.Stage2ElementModel === 0 &&
                    (Stage2ElementModel.touched || Stage2ElementModel.dirty)
                  ">
                  This field is required
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2ElementsVessel" class="form-label">Elements/Vessels</label>
            </div>
            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage2ElementsVessel"
                name="Stage2ElementsVessel" [(ngModel)]="addTrainRequest.Stage2ElementsVessel" autocomplete="on"
                #Stage2ElementsVessel="ngModel" />
              <div *ngIf="
                  Stage2ElementsVessel.invalid &&
                  (Stage2ElementsVessel.dirty || Stage2ElementsVessel.touched)
                "></div>
              <div *ngIf="Stage2elementVesselsValidator">
                This field is required
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2Vessels" class="form-label"># Of Vessels</label>
            </div>
            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage2Vessels" name="Stage2Vessels"
                [(ngModel)]="addTrainRequest.Stage2Vessels" autocomplete="on" #Stage2Vessels="ngModel"
                (input)="Stage2VesselsChange()" />
              <div *ngIf="
                  Stage2Vessels.invalid &&
                  (Stage2Vessels.dirty || Stage2Vessels.touched)
                "></div>
              <div *ngIf="stage2VesselValidator">This field is required</div>
            </div>
          </div>
        </div>

        <!-- stage 2 hybrid -->
        <div id="stage2hybrid" *ngIf="showStage2hybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2ElementModel" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stage2ElementModel"
                  name="Stage2ElementModel" id="Stage2ElementModel" #Stage2ElementModelH="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
                <div *ngIf="stage2Element1validatorH">
                  This field is required
                </div>
                <div *ngIf="
                    addTrainRequest.Stage2ElementModel === 0 &&
                    (Stage2ElementModelH.touched || Stage2ElementModelH.dirty)
                  ">
                  This field is required
                </div>
              </div>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="Stage2Element1Qty" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3" style="text-align: left">
              <input type="text" class="form-control border border-dark" id="Stage2Element1Qty" name="Stage2Element1Qty"
                [(ngModel)]="addTrainRequest.Stage2Element1Qty" autocomplete="on" (change)="QuantityAdditionStage2()"
                #Stage2Element1QtyH="ngModel" (input)="Stage2Q1Change()" />
              <div *ngIf="
                  Stage2Element1QtyH.invalid &&
                  (Stage2Element1QtyH.dirty || Stage2Element1QtyH.touched)
                "></div>
              <div *ngIf="s2Q1Validator">This field is required</div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2Element2Model" class="form-label">Element2:</label>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Stage2Element2Model"
                  name="Stage2Element2Model" id="Stage2Element2Model" #Stage2Elemen2tModel="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
                <div *ngIf="stage2Element2validatorH">
                  This field is required
                </div>
                <div *ngIf="
                    addTrainRequest.Stage2Element2Model === 0 &&
                    (Stage2Elemen2tModel.touched || Stage2Elemen2tModel.dirty)
                  ">
                  This field is required
                </div>
              </div>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="Stage2Element2Qty" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3">
              <input type="text" class="form-control border border-dark" id="Stage2Element2Qty" name="Stage2Element2Qty"
                [(ngModel)]="addTrainRequest.Stage2Element2Qty" autocomplete="on" (change)="QuantityAdditionStage2()"
                #Stage2Element2Qty="ngModel" (input)="Stage2Q2Change()" />
              <div *ngIf="
                  Stage2Element2Qty.invalid &&
                  (Stage2Element2Qty.dirty || Stage2Element2Qty.touched)
                "></div>
              <div *ngIf="s2Q2Validator">This field is required</div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2Element3Model" class="form-label">Element3:</label>
            </div>
            <div class="col-sm-4">

              <div class="form-group">
                <select class="form-select border border-dark"
                  [(ngModel)]="addTrainRequest.Stage2Element3Model" name="Stage2Element3Model" id="Stage2Element3Model"
                  #Stage2ElementModel="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-1" style="text-align: left">
              <label for="Stage2Element3Qty" class="form-label">Qty:</label>
            </div>

            <div class="col-sm-3">
              <input type="text" class="form-control border border-dark" id="Stage2Element3Qty" name="Stage2Element3Qty"
                [(ngModel)]="addTrainRequest.Stage2Element3Qty" autocomplete="on" (change)="QuantityAdditionStage2()" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2ElementsVessel" class="form-label">Elements/Vessels</label>
            </div>

            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage2ElementsVessel"
                name="Stage2ElementsVessel" [(ngModel)]="addTrainRequest.Stage2ElementsVessel" autocomplete="on"
                [disabled]="true" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2Vessels" class="form-label"># Of Vessels</label>
            </div>
            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage2Vessels" name="Stage2Vessels"
                [(ngModel)]="addTrainRequest.Stage2Vessels" autocomplete="on" #Stage2Vessels="ngModel"
                (input)="Stage2VesselsChange()" />
              <div *ngIf="
                  Stage2Vessels.invalid &&
                  (Stage2Vessels.dirty || Stage2Vessels.touched)
                "></div>
              <div *ngIf="stage2VesselValidatorH">This field is required</div>
            </div>
          </div>
        </div>
      </div>
      <!-- stage 2 Ends -->

      <!--stage 3 Starts -->
      <div id="stage3" *ngIf="showDiv2">
        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <b>Stage 3</b>
          </div>
          <div class="col-sm-4">

          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="Hybrid3" class="form-label">Hybrid</label>
          </div>
          <div class="col-sm-4">
            <select class="form-select border border-dark" [(ngModel)]="addTrainRequest.Hybrid3" name="Hybrid3"
              id="Hybrid3" (change)="onOptionHybridS3()">
              <option *ngFor="let hybrids3 of hybridSt3" [ngValue]="hybrids3.Id">
                {{ hybrids3.Name }}
              </option>
            </select>
          </div>
        </div>

        <!-- stage 3 non hybrid -->
        <div id="stage3Nhybrid" *ngIf="stage3Nhybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3ElementModel" class="form-label">Element:</label>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <select class="form-select border border-dark"
                  [(ngModel)]="addTrainRequest.Stage3ElementModel" name="Stage3ElementModel" id="Stage3ElementModel"
                  #Stage3ElementModel="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
                <div *ngIf="stage3Element1validatorNH">
                  This field is required
                </div>
                <div *ngIf="
                    addTrainRequest.Stage3ElementModel === 0 &&
                    (Stage3ElementModel.touched || Stage3ElementModel.dirty)
                  ">
                  This field is required
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3ElementsVessel" class="form-label">Elements/Vessels</label>
            </div>
            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage3ElementsVessel"
                name="Stage3ElementsVessel" [(ngModel)]="addTrainRequest.Stage3ElementsVessel" autocomplete="on"
                #Stage3ElementsVessel="ngModel" />
              <div *ngIf="
                  Stage3ElementsVessel.invalid &&
                  (Stage3ElementsVessel.dirty || Stage3ElementsVessel.touched)
                ">
                This field is required
              </div>
              <div *ngIf="Stage3elementVesselsValidator">
                This field is required
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3Vessels" class="form-label"># Of Vessels</label>
            </div>
            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage3Vessels" name="Stage3Vessels"
                [(ngModel)]="addTrainRequest.Stage3Vessels" autocomplete="on" #Stage3Vessels="ngModel"
                (input)="Stage3VesselsChange()" />
              <div *ngIf="
                  Stage3Vessels.invalid &&
                  (Stage3Vessels.dirty || Stage3Vessels.touched)
                ">
                This field is required
              </div>
              <div *ngIf="stage3VesselValidator">This field is required</div>
            </div>
          </div>
        </div>

        <!-- stage 3 hybrid -->
        <div id="stage3hybrid" *ngIf="showStage3hybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3ElementModel" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <select class="form-select border border-dark"
                  [(ngModel)]="addTrainRequest.Stage3ElementModel" name="Stage3ElementModel" id="Stage3ElementModel"
                  #Stage3ElementModel="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
                <div *ngIf="stage3Element1ValidatorH">
                  This field is required
                </div>
                <div *ngIf="
                    addTrainRequest.Stage3ElementModel === 0 &&
                    (Stage3ElementModel.touched || Stage3ElementModel.dirty)
                  ">
                  This field is required
                </div>
              </div>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="Stage3Element1Qty" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3" style="text-align: left">
              <input type="text" class="form-control border border-dark" id="Stage3Element1Qty" name="Stage3Element1Qty"
                [(ngModel)]="addTrainRequest.Stage3Element1Qty" autocomplete="on" (change)="QuantityAdditionStage3()"
                #Stage3Element1Qty="ngModel" (inout)="Stage3Q1Change()" />
              <div *ngIf="
                  Stage3Element1Qty.invalid &&
                  (Stage3Element1Qty.dirty || Stage3Element1Qty.touched)
                "></div>
              <div *ngIf="s3Q1ValidatorH">This field is required</div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3Element2Model" class="form-label">Element2:</label>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <select class="form-select border border-dark"
                  [(ngModel)]="addTrainRequest.Stage3Element2Model" name="Stage3Element2Model" id="Stage3Element2Model"
                  #Stage3Element2Model="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
                <div *ngIf="stage3Element2Validator">
                  This field is required
                </div>
                <div *ngIf="
                    addTrainRequest.Stage3Element2Model === 0 &&
                    (Stage3Element2Model.touched || Stage3Element2Model.dirty)
                  ">
                  This field is required
                </div>
              </div>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="Stage3Element2Qty" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3">
              <input type="text" class="form-control border border-dark" id="Stage3Element2Qty" name="Stage3Element2Qty"
                [(ngModel)]="addTrainRequest.Stage3Element2Qty" autocomplete="on" (change)="QuantityAdditionStage3()"
                #Stage3Element2Qty="ngModel" (input)="Stage3Q2Change()" />
              <div *ngIf="
                  Stage3Element2Qty.invalid &&
                  (Stage3Element2Qty.dirty || Stage3Element2Qty.touched)
                "></div>
              <div *ngIf="s3Q2Validator">This field is required</div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3Element3Model" class="form-label">Element3:</label>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <select class="form-select border border-dark"
                  [(ngModel)]="addTrainRequest.Stage3Element3Model" name="Stage3Element3Model" id="Stage3Element3Model"
                  #Stage3Element2Model="ngModel">
                  <option [ngValue]="0">Select a Model</option>
                  <option *ngFor="let model of models" [ngValue]="model.Id">
                    {{ model.Name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-1" style="text-align: left">
              <label for="Stage3Element3Qty" class="form-label">Qty:</label>
            </div>

            <div class="col-sm-3">
              <input type="text" class="form-control border border-dark" id="Stage3Element3Qty" name="Stage3Element3Qty"
                [(ngModel)]="addTrainRequest.Stage3Element3Qty" autocomplete="on" (change)="QuantityAdditionStage3()" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3ElementsVessel" class="form-label">Elements/Vessels</label>
            </div>

            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage3ElementsVessel"
                name="Stage3ElementsVessel" [(ngModel)]="addTrainRequest.Stage3ElementsVessel" autocomplete="on" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage3Vessels" class="form-label"># Of Vessels</label>
            </div>
            <div class="col-sm-4">
              <input type="text" class="form-control border border-dark" id="Stage3Vessels" name="Stage3Vessels"
                [(ngModel)]="addTrainRequest.Stage3Vessels" autocomplete="on" #Stage3Vessels="ngModel"
                (input)="(Stage3VesselsChange)" />
              <div *ngIf="
                  Stage3Vessels.invalid &&
                  (Stage3Vessels.dirty || Stage3Vessels.touched)
                ">
                This field is required
              </div>
              <div *ngIf="stage3VesselValidatorH">This field is required</div>
            </div>
          </div>
        </div>
      </div>
      <!--stage 3 Ends -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <b>User Defined Fields:</b>
        </div>
      </div>
      <!-- user defined field 1 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud1" class="form-label">Field 1:</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control border border-dark" id="Field1" name="Field1"
            [(ngModel)]="addTrainRequest.Ud1" autocomplete="on" />
        </div>
      </div>
      <!-- user defined field 2 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud2" class="form-label">Field 2:</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control border border-dark" id="Field2" name="Field2"
            [(ngModel)]="addTrainRequest.Ud2" autocomplete="on" />
        </div>
      </div>
      <!-- user defined field 3 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud3" class="form-label">Field 3:</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control border border-dark" id="Field3" name="Field3"
            [(ngModel)]="addTrainRequest.Ud3" autocomplete="on" />
        </div>
      </div>
      <!-- user defined field 4 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud4" class="form-label">Field 4:</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control border border-dark" id="Field4" name="Field4"
            [(ngModel)]="addTrainRequest.Ud4" autocomplete="on" />
        </div>
      </div>
      <!-- user defined field 5 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud4" class="form-label">Field 5:</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control border border-dark" id="Field5" name="Field5"
            [(ngModel)]="addTrainRequest.Ud5" autocomplete="on" />
        </div>
      </div>
<div class="row mb-3">
  <div class="col-sm-3"></div>

  <div class="col-sm-9 d-flex gap-2">
    <button type="submit" class="btn custom-buttons-btn">
      Create
    </button>

    <button type="button" class="btn custom-buttons-btn" (click)="onCancel()">
      Cancel
    </button>
  </div>
</div>
    </div>
  </form>
  <!-- Form End -->
</div>